import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const headerContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  padding: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  background: sharedStyles.Colors.Tints.NEUTRAL[7],
  borderRadius: toPx(sharedStyles.BorderRadius.SMALL),
}

export const headerTextStyle: React.CSSProperties = {
  ...sharedStyles.subheading,
}

export const headerSubtextStyle: React.CSSProperties = {
  ...sharedStyles.small,
  color: sharedStyles.Colors.Tints.NEUTRAL[2],
}

export const bodyTextStyle: React.CSSProperties = {
  ...sharedStyles.text,
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}

export const footerTextStyle: React.CSSProperties = {
  ...sharedStyles.small,
  marginTop: '4px',
  color: sharedStyles.Colors.SECONDARY,
}
